import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center bg-white px-4 text-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full">
            {/* Mobile */}
            <div className="md:hidden">
                <h1 className="text-6xl font-bold text-[#3A57FF] mb-4">404</h1>
                <div className="text-lg text-gray-600 mb-6">The page you are looking for doesn't exist.</div>
                <button
                    onClick={() => navigate('/')}
                    className="px-6 py-3 bg-[#3A57FF] text-white rounded-2xl shadow-lg hover:bg-blue-700 transition"
                >
                    Back to Home
                </button>
            </div>

            {/* Desktop */}
            <div className="hidden md:flex flex-col items-center">
                <h1 className="text-9xl font-extrabold text-[#3A57FF] mb-6">404</h1>
                <p className="text-2xl text-gray-600 mb-8">Oops! We couldn't find the page you were looking for.</p>
                <button
                    onClick={() => navigate('/')}
                    className="px-8 py-4 bg-[#3A57FF] text-white text-lg rounded-2xl shadow-xl hover:bg-blue-700 transition"
                >
                    Go Back Home
                </button>
            </div>
        </div>
    );
};

export default NotFoundPage;
